import { Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import { useTranslate } from 'react-admin';
import "react-datepicker/dist/react-datepicker.css";
import globalUseStyles from '../../styles/globalCustomStyles';

const ChooseUsageButton = ({ title, usages, usage, setUsage }) => {
    const globalClasses = globalUseStyles();
    const t = useTranslate();

    return (
        <div className={globalClasses.usageSelector}>
            <Typography variant="h9">{title}</Typography>
            <Select
                value={usage}
                onChange={(event) => {
                    setUsage(event.target.value);
                }}
                input={<OutlinedInput label="Usage" />}
            >
                {usages.map((usage_item) => (
                    <MenuItem
                        key={usage_item}
                        value={usage_item}
                        className={globalClasses.usageMenuItem}
                    >
                        {t(`sites.energetic_performance.general.usages.${usage_item}`)}
                    </MenuItem>
                ))}
            </Select>

        </div>
    )
}

export default ChooseUsageButton;